export default "/images/link.svg?0e17f72a57b2fea8084fe0c43ce51959";